import { px, calculateDisplayRect } from './utils.js';
const handlerFactory = (handle) => (event) => {
    event.stopPropagation();
    const detail = event.detail;
    handle === null || handle === void 0 ? void 0 : handle(detail);
};
export const createResizer = (config) => {
    const { target } = config;
    const resizer = document.createElement('exeditor-block-resizer');
    if (config.keepAspectRatio) {
        resizer.setAttribute('keep-aspect-ratio', 'true');
    }
    resizer.addEventListener('customresizestart', handlerFactory(config.onResizeStart));
    resizer.addEventListener('customresizeend', handlerFactory(config.onResizeEnd));
    resizer.addEventListener('customresize', handlerFactory(config.onResize));
    Object.assign(resizer.style, {
        display: 'block',
        position: 'absolute',
        transformOrigin: '0 0',
    });
    const update = (attrs = {}) => {
        const width = target.offsetWidth;
        const height = target.offsetHeight;
        const rotate = attrs.rotate || 0;
        const result = calculateDisplayRect({ width, height, rotate });
        Object.assign(resizer.style, {
            width: px(width),
            height: px(height),
            top: rotate ? px(result.offsetY) : '0',
            left: rotate ? px(result.offsetX) : '0',
            transform: `rotate(${rotate || 0}rad)`,
        });
        Object.assign(resizer, {
            width,
            height,
            rotate: rotate || 0,
            max: attrs.max,
        });
    };
    return {
        resizer,
        update,
    };
};
export const createCropper = (config) => {
    const { targetCrop, targetMove, keepAspectRatio } = config;
    const cropper = document.createElement('exeditor-block-cropper');
    if (keepAspectRatio) {
        cropper.setAttribute('keep-aspect-ratio', 'true');
    }
    cropper.addEventListener('custommove', handlerFactory(config.onMove));
    cropper.addEventListener('customcrop', handlerFactory(config.onCrop));
    cropper.addEventListener('customresizeend', handlerFactory(config.onResizeEnd));
    Object.assign(cropper.style, {
        display: 'block',
        position: 'absolute',
        transformOrigin: '0 0',
    });
    const update = (attrs = {}) => {
        const { src, offsetWidth: width, offsetHeight: height } = targetMove;
        const crop = {
            width: targetCrop.offsetWidth,
            height: targetCrop.offsetHeight,
            x: targetMove.offsetLeft,
            y: targetMove.offsetTop,
        };
        const rotate = attrs.rotate || 0;
        const result = calculateDisplayRect({
            width: crop.width,
            height: crop.height,
            rotate,
        });
        Object.assign(cropper.style, {
            width: px(crop.width),
            height: px(crop.height),
            top: rotate ? px(result.offsetY) : '0',
            left: rotate ? px(result.offsetX) : '0',
            transform: `rotate(${rotate || 0}rad)`,
        });
        Object.assign(cropper, {
            src,
            width,
            height,
            crop,
            rotate,
            max: attrs.max,
        });
    };
    return {
        cropper,
        update,
    };
};
//# sourceMappingURL=helper.js.map